import { render, staticRenderFns } from "./PasswordViewSidebar.vue?vue&type=template&id=37d0b1c5&scoped=true&"
import script from "./PasswordViewSidebar.vue?vue&type=script&lang=js&"
export * from "./PasswordViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PasswordViewSidebar.vue?vue&type=style&index=0&id=37d0b1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0b1c5",
  null
  
)

export default component.exports